import axios from 'axios';

export default function ({state}, val) {
    return new Promise((resolve, reject)=>{
        state.loadingReports.push(val.WebReportId);
        let url = val.Url.replace(/ /g, '').replace(/report\/report/g, 'report/GeneratedReport');
        axios({
            method: 'get',
            url,
        }).then(({data})=>{
            state.loadingReports = state.loadingReports.filter(i=>i!==val.WebReportId);
            let tempDiv = document.createElement("div");
            tempDiv.innerHTML= data;
            window.frames["print_frame"].document.body.innerHTML = tempDiv.querySelector('#_page_').innerHTML;
            window.frames["print_frame"].window.focus();
            window.frames["print_frame"].window.print();
            resolve(state);
        }).catch(err=>{
            console.log(err);
            reject();
        });
    });
}